import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import god from "../assets/god1.png";
import Header from "./Header";
import Footer from "./Footer";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { motion } from "framer-motion";
import k1 from "../assets/k1.png";
import k2 from "../assets/k2.png";
import k3 from "../assets/k3.png";

import Slider from "react-slick";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

const categoryCards = [
  { title: "Aksharabhyasam", img: k1 },
  { title: "Annaprasana", img: k2 },
  { title: "Marriage", img: k3 },
  { title: "Naamkaranam", img: k1 },
  { title: "Annadanam", img: k2 },
  { title: "Gayatri Japam", img: k3 },
];

const AboutUs = () => {
  const itemVariantsLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const itemVariantsRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8 } },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // 5 seconds
    responsive: [
      {
        breakpoint: 960, // md
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600, // xs
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Box sx={{ overflow: "hidden" }}>
        <Header />
        <Grid
          container
          spacing={3}
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          sx={{ p: { xs: 2, md: 6 }, mt: 10 }}
        >
          <Grid
            component={motion.div}
            variants={itemVariantsLeft}
            size={{ xs: 12, md: 6 }}
          >
            <img src={god} alt="" style={{ width: "100%" }} />
          </Grid>
          <Grid
            component={motion.div}
            variants={itemVariantsRight}
            size={{ xs: 12, md: 6 }}
            sx={{ mt: 6 }}
          >
            <Typography
              sx={{ fontWeight: "bold", fontSize: 20, color: "#6d1675" }}
            >
              About Us
            </Typography>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: 28,
                mt: 1,
                lineHeight: 1.2,
              }}
            >
              Puja Services – Your Digital Gateway to Hindu Spirituality!
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
              }}
            />
            <Typography sx={{ textAlign: "justify" }}>
              Puja Services is the leading digital platform for all Hindu
              devotional needs and spiritual services. Designed to seamlessly
              connect the present and future generations to Hinduism, our
              platform is accessible through a Web Portal, Android, and iOS
              apps. In today's fast-paced world of globalization and technology,
              cultural roots are fading as western influences grow. Ancient
              traditions, values, and customs are at risk of being lost. Puja
              Services is dedicated to preserving and passing down the rich
              heritage, history, and spiritual essence of Hinduism to future
              generations.
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 4,
                mt: 3,
              }}
            >
              {[
                {
                  title: "Our Vision",
                  desc: "Is to inspire and instill devotion in future generations toward Hindu Dharma through advanced technology.",
                  icon: <FavoriteBorderIcon sx={{ color: "#fff" }} />,
                },
                {
                  title: "Our Mission",
                  desc: "To bring all Spiritual Services and Traditions of Hindu Dharma on to a Single Digital Platform.",
                  icon: <MenuBookIcon sx={{ color: "#fff" }} />,
                },
              ].map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    p: 3,
                    borderRadius: 3,
                    border: "1px solid #aaa",
                  }}
                >
                  <Box
                    sx={{
                      width: 50,
                      height: 50,
                      bgcolor: "#6d1675",
                      borderRadius: "50%",
                      mb: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "0.3s",
                      "&:hover": {
                        bgcolor: "#9c27b0", // hover color for icon background
                      },
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography sx={{ fontSize: 22, fontWeight: "bold" }}>
                    {item.title}
                  </Typography>
                  <Typography>{item.desc}</Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ p: { xs: 2, md: 6 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              sx={{ fontWeight: "bold", fontSize: 20, color: "#6d1675" }}
            >
              Team
            </Typography>
            <Typography
              sx={{ fontWeight: "bold", fontSize: 28, mt: 1, lineHeight: 1.2 }}
            >
              Our Management
            </Typography>
            <Divider
              sx={{
                width: 100,
                borderBottomWidth: 5,
                borderColor: "#ffc20f",
                my: 2,
                mx: "auto",
              }}
            />
          </Box>

          <Slider {...settings}>
            {categoryCards.map((card, index) => (
              <Box key={index} sx={{ ml: { xs: 0, md: -1 } }}>
                <Card
                  sx={{
                    cursor: "pointer",
                    textAlign: "center",
                    border: "1px solid #ddd",
                    // position: "relative",
                    // overflow: "hidden",
                    ml: { xs: 0, md: 2 },

                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      height="auto"
                      image={card.img}
                      alt={card.title}
                    />

                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "92%",
                        bgcolor: "rgba(0,0,0,0.6)",
                        color: "#fff",
                        opacity: 0,
                        transition: "opacity 0.3s",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        p: 2,
                        gap: 1,
                        "&:hover": {
                          opacity: 1,
                        },
                      }}
                    >
                      <IconButton
                        sx={{ bgcolor: "#3b5998", color: "#fff", mb: 1 }}
                      >
                        <FacebookIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        sx={{ bgcolor: "#E1306C", color: "#fff", mb: 1 }}
                      >
                        <InstagramIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        sx={{ bgcolor: "#1DA1F2", color: "#fff", mb: 1 }}
                      >
                        <TwitterIcon fontSize="small" />
                      </IconButton>
                      <IconButton sx={{ bgcolor: "#FF0000", color: "#fff" }}>
                        <YouTubeIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>

                  <CardContent sx={{ bgcolor: "#6d1675", color: "#fff" }}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                      {card.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
        <Footer />
      </Box>
    </>
  );
};

export default AboutUs;

